import { formatDateTime } from '@/lib/datetime';
import { relativeTime } from '@/lib/relative-time';
import { Show } from 'solid-js';

/** Relative label ("12 days ago") with the exact timestamp on hover. */
export const When = (props: { date: string | null | undefined; class?: string }) => (
  <Show when={props.date && relativeTime(props.date)}>
    {(rel) => (
      <span
        class={props.class ?? 'shrink-0 text-xs text-neutral-400'}
        title={formatDateTime(props.date ?? '')}
      >
        {rel()}
      </span>
    )}
  </Show>
);
